module.exports = __webpack_public_path__ + "static/media/tint_car_6.ab8cac6a.svg";